/**
 * 加载状态组件
 */
import React from 'react';

const Loading = ({ text = '加载中...', fullscreen = false }) => (
  <div className={`loading-container ${fullscreen ? 'loading-fullscreen' : ''}`}>
    <div className="loading-spinner"></div>
    {text && <span className="loading-text">{text}</span>}
  </div>
);

export default Loading;
